import Vue from 'vue'
import Vuex from 'vuex'

/**
 * Módulos do Vuex
 */
import moduleChangelog from './modules/moduleChangelog'
// import moduleDashboardAnalytics from "./modules/moduleDashboardAnalytics";
import moduleDadosHistoricos from './modules/moduleDadosHistoricos'
import moduleDashboardCardInfo from './modules/moduleDashboardCardInfo'
import moduleImportShape from './modules/moduleImportShape'
import moduleMapData from './modules/moduleMapData'
import moduleMessages from './modules/moduleMessages'
import moduleReports from './modules/moduleReports'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		moduleMessages,
		moduleMapData,
		moduleImportShape,
		moduleDashboardCardInfo,
		moduleChangelog,
		moduleReports,
		moduleDadosHistoricos,
		// moduleDashboardAnalytics
	},
})
